import { BottomSheetMobileLayout } from "@l2r-front/l2r-ui"

import { Map } from "../../containers/Map"

import { CampaignMapRouterMobile } from "../CampaignMapRouter"
import { SidebarRouter } from "../SidebarRouter"

export function CampaignMobileRouter() {

    return <BottomSheetMobileLayout
        BottomSheetRouter={SidebarRouter}
        MapComponent={Map}
        MapRouter={CampaignMapRouterMobile}
    />
}
